import { ContentTiles } from '@ahmdigital/ui';
import type { ComponentProps } from 'react';

import mapContent, { type ItemType } from './utils/map-content';
import styles from './styles.module.sass';

export type ContentTilesProps = {
  items: {
    item: ItemType;
    name?: string;
    release?: {
      endTime: string;
      startTime: string;
    };
  }[];
};

const ContentTilesHome = ({ items }: ContentTilesProps) => {
  const contentTiles = mapContent(items.map(({ item }) => item)).map(({ _id, ...tile }) => ({
    ...tile,
    id: _id,
    variant: 'vertical',
  })) as ComponentProps<typeof ContentTiles>['tiles'];

  return (
    <div className={styles.contentTileWrapper}>
      <ContentTiles tiles={contentTiles} />
    </div>
  );
};

export default ContentTilesHome;
